import { yupResolver } from "@hookform/resolvers/yup";
import axios from "axios";
import apiEndpoints from "configs/apiEndPoints";
import { FC } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useQueryCustom } from "utils/useQueryCUstom";
import { duplicateValidation, fieldNames } from "./duplicationValidation";
import SelectInputAsync from "components/inputs/SlectInputAsync";
import Button from "components/Button";

interface DuplicationProps {
  // Define any props you need here
  submitData: (data: any) => void;
  isLoading: boolean;
}

export interface FormValues {
  visaTypes: { value: string; label: string }[];
  countryPairs: { value: string; label: string }[];
}

const Duplication: FC<DuplicationProps> = ({ submitData, isLoading }) => {
  const { t } = useTranslation();

  const methods = useForm<FormValues>({
    resolver: yupResolver(duplicateValidation(t)),
  });

  return (
    <div>
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(submitData)} className="py-8 flex flex-col gap-10 ">
          <SelectInputAsync isMulti valueIsCode={false} name={fieldNames.visaTypes} apiName="visa-types" label={fieldNames.visaTypes} isRequired />
          <SelectInputAsync isMulti valueIsCode={false} name={fieldNames.countryPairs} apiName="country-pairs" label={fieldNames.countryPairs} isRequired />
          <Button type="submit" variant="success" isFullSize loading={isLoading}>
            {t("submit")}
          </Button>
        </form>
      </FormProvider>
    </div>
  );
};
export default Duplication;
